import axios from "axios";

// Post request to login using sso
export async function sso_login_request(token) {
  const res = await axios.post(`/leap/sso`, {
    token: token,
  },{
    headers: { 'X-CSRF-Token': document.querySelector('meta[name="csrf-token"]').content, },
  });
  return res.data;
}
